module.exports = __webpack_public_path__ + "img/convergists8.b9442ec5.png";